(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("changeEmployeePositionButton", {
            controller: ChangeEmployeePositionButtonComponent,
            bindings: {
                onClick: '&',
                type: '@',
                usersIds: '<',
                brandId: '@',
                docCardId: '@',
                startDate: '<',
                isBrandArchived: '<'
            },
            controllerAs: 'changeEmployeePositionButton',
            templateUrl: '../hmodules/on-boarding/components/change-employee-position-button/change-employee-position-button.component.html'
        });

    ChangeEmployeePositionButtonComponent.$inject = ['$scope', '$modal'];

    function ChangeEmployeePositionButtonComponent($scope, $modal) {

        var self = this;

        self.$onInit = function () {
            if (typeof (self.usersIds) !== 'undefined') {
                self.users = angular.copy(self.usersIds);
            }
        };

        self.$onChanges = function (changes) {
            if (
                changes.usersIds &&
                !changes.usersIds.isFirstChange() &&
                JSON.stringify(changes.usersIds.currentValue) !== JSON.stringify(changes.usersIds.previousValue)
            ) {
                self.users = angular.copy(changes.usersIds.currentValue);
            }
        };

        self.onButtonClicked = function () {
            if (!self.isBrandArchived) {
                $modal({
                    controller: 'ChangeEmployeePositionModal',
                    controllerAs: 'ChangeEmployeePositionModal',
                    templateUrl: '../hmodules/on-boarding/modals/change-employee-position/change-employee-position.modal.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: function () {
                            return {
                                usersIds: self.users,
                                brandId: parseInt(self.brandId),
                                cardId: parseInt(self.docCardId),
                                startDate: self.startDate
                            };
                        }
                    }
                });

                self.onClick();
            }
        };
    }
})();
